import { createFileRoute } from '@tanstack/react-router'

import { RolesDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/roles-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/roles')({
  component: () => (
    <PermissionChecker requiredPermissions={['role.read']}>
      <RolesDocumentationPage />
    </PermissionChecker>
  ),
})
